import styled from 'styled-components'

const Flyout = styled.div`
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].lg}) {
    margin-top: 0;
  }
`

const FlyoutParagraph = styled.p`
  line-height: 20px;
  margin: 0 0 20px;
`

const FlyoutText = styled.span`
  line-height: 20px;
  margin: 0 0 20px;
  ul {
    list-style: inherit;
    padding-left: 25px;
  }
`

const MiddleSeperator = styled.div`
  border-bottom: ${(props) => props.theme.size.border.width.md} solid ${(props) => props.theme.color.monochrome.darker};
  margin: 10px;
`

const FlyoutList = styled.ol`
  counter-reset: li;
`

const FlyoutListItem = styled.li`
  counter-increment: li;
  margin: 10px 0;
  padding-left: 35px;
  position: relative;
  line-height: 20px;

  &::before {
    content: counter(li);
    position: absolute;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: ${(props) => props.theme.color.monochrome.darker};
    border-radius: 50%;
    display: inline-block;
    color: ${(props) => props.theme.color.monochrome.white};
    font-size: 14px;
    line-height: 20px;
    text-align: center;
  }
`

const TC = styled.div`
  font-size: 12px;
  margin: 20px 0;
`

const BulletPadding = styled.ul`
  padding-left: 10px;
`

const BulletList = styled.li`
  list-style: initial;
  margin: 10px 0;
  font-size: 14px;
`

export {
  Flyout,
  FlyoutParagraph,
  FlyoutText,
  MiddleSeperator,
  FlyoutList,
  FlyoutListItem,
  TC,
  BulletPadding,
  BulletList
}
